module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subfooter"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('div', {
    staticClass: "copyrights"
  }, [_vm._v("\n                    Copyright 2017  "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Hotel CEO Group")]), _vm._v(" Todos los derechos reservados.\n                ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('div', {
    staticClass: "social_media"
  }, [_c('social-item', {
    attrs: {
      "type": "facebook"
    }
  }), _vm._v(" "), _c('social-item', {
    attrs: {
      "type": "twitter"
    }
  }), _vm._v(" "), _c('social-item', {
    attrs: {
      "type": "googleplus"
    }
  }), _vm._v(" "), _c('social-item', {
    attrs: {
      "type": "pinterest"
    }
  }), _vm._v(" "), _c('social-item', {
    attrs: {
      "type": "linkedin"
    }
  }), _vm._v(" "), _c('social-item', {
    attrs: {
      "type": "instagram"
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fddf4ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subfooter/Subfooter.vue
// module id = 387
// module chunks = 0